/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CloseDeliveries200ResponseFailedInner } from './CloseDeliveries200ResponseFailedInner';
import {
    CloseDeliveries200ResponseFailedInnerFromJSON,
    CloseDeliveries200ResponseFailedInnerFromJSONTyped,
    CloseDeliveries200ResponseFailedInnerToJSON,
    CloseDeliveries200ResponseFailedInnerToJSONTyped,
} from './CloseDeliveries200ResponseFailedInner';

/**
 * 
 * @export
 * @interface CloseDeliveries200Response
 */
export interface CloseDeliveries200Response {
    /**
     * 
     * @type {Array<CloseDeliveries200ResponseFailedInner>}
     * @memberof CloseDeliveries200Response
     */
    failed: Array<CloseDeliveries200ResponseFailedInner>;
}

/**
 * Check if a given object implements the CloseDeliveries200Response interface.
 */
export function instanceOfCloseDeliveries200Response(value: object): value is CloseDeliveries200Response {
    if (!('failed' in value) || value['failed'] === undefined) return false;
    return true;
}

export function CloseDeliveries200ResponseFromJSON(json: any): CloseDeliveries200Response {
    return CloseDeliveries200ResponseFromJSONTyped(json, false);
}

export function CloseDeliveries200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CloseDeliveries200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'failed': ((json['failed'] as Array<any>).map(CloseDeliveries200ResponseFailedInnerFromJSON)),
    };
}

export function CloseDeliveries200ResponseToJSON(json: any): CloseDeliveries200Response {
    return CloseDeliveries200ResponseToJSONTyped(json, false);
}

export function CloseDeliveries200ResponseToJSONTyped(value?: CloseDeliveries200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'failed': ((value['failed'] as Array<any>).map(CloseDeliveries200ResponseFailedInnerToJSON)),
    };
}

